(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-play/assets/react/components/betslip-details-ab-test.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-play/assets/react/components/betslip-details-ab-test.js');

'use strict';

function _toArray(r) { return _arrayWithHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableRest(); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const Button = svs.ui.ReactButton;
const formatCurrency = svs.utils.format.Currency;
const _svs$lyckoplatsen$com = svs.lyckoplatsen.components.page_play.react.components,
  BetslipLocationNameInput = _svs$lyckoplatsen$com.BetslipLocationNameInput,
  CharityLogoABTest = _svs$lyckoplatsen$com.CharityLogoABTest;
const IconButton = svs.ui.ReactIconButton;
const Icon = svs.ui.ReactIcon;
const _svs$ui$reactForm = svs.ui.reactForm,
  RadioGroup = _svs$ui$reactForm.RadioGroup,
  ControlGroup = _svs$ui$reactForm.ControlGroup,
  RadioButton = _svs$ui$reactForm.RadioButton,
  Radio = _svs$ui$reactForm.Radio,
  Form = _svs$ui$reactForm.Form;
const _React = React,
  useEffect = _React.useEffect,
  useState = _React.useState;
const _svs$lyckoplatsen$com2 = svs.lyckoplatsen.components.page_play.jotai.atoms,
  pinLocationAtom = _svs$lyckoplatsen$com2.pinLocationAtom,
  locationConfirmedAtom = _svs$lyckoplatsen$com2.locationConfirmedAtom,
  shouldAutoPayAtom = _svs$lyckoplatsen$com2.shouldAutoPayAtom,
  shouldPayAfterDepositAtom = _svs$lyckoplatsen$com2.shouldPayAfterDepositAtom,
  pinLocationTypeAtom = _svs$lyckoplatsen$com2.pinLocationTypeAtom,
  isGameValidAtom = _svs$lyckoplatsen$com2.isGameValidAtom,
  isProlonginationAtom = _svs$lyckoplatsen$com2.isProlonginationAtom,
  numberOfWeeksAtom = _svs$lyckoplatsen$com2.numberOfWeeksAtom,
  lyckoplatsenNameAtom = _svs$lyckoplatsen$com2.lyckoplatsenNameAtom,
  shouldDisablePayButtonAtom = _svs$lyckoplatsen$com2.shouldDisablePayButtonAtom,
  isDefaultSubscriptionAtom = _svs$lyckoplatsen$com2.isDefaultSubscriptionAtom;
const locationNameAtom = svs.lyckoplatsen.shared_map.atoms.locationNameAtom;
const _svs$lyckoplatsen$com3 = svs.lyckoplatsen.components.shared_draws.jotai.atoms,
  primaryDrawAtom = _svs$lyckoplatsen$com3.primaryDrawAtom,
  secondaryDrawAtom = _svs$lyckoplatsen$com3.secondaryDrawAtom,
  firstDrawAtom = _svs$lyckoplatsen$com3.firstDrawAtom,
  lastDrawAtom = _svs$lyckoplatsen$com3.lastDrawAtom;
const charityAtom = svs.lyckoplatsen.shared_charity.jotai.atoms.charityAtom;
const _jotai = jotai,
  useSetAtom = _jotai.useSetAtom,
  useAtom = _jotai.useAtom,
  useAtomValue = _jotai.useAtomValue,
  atom = _jotai.atom;
const _ReactRouterDOM = ReactRouterDOM,
  useHistory = _ReactRouterDOM.useHistory,
  useParams = _ReactRouterDOM.useParams;
const useResetPlayAtoms = svs.lyckoplatsen.components.page_play.react.hooks.useResetPlayAtoms;
const CONSTANTS = svs.lyckoplatsen.components.shared_constants.CONSTANTS;
const getDefaultLocationName = svs.tur.lyckoplatsen.utils.getDefaultLocationName;
const isSelfService = svs.core.config.data.svsconfig.isSelfService;
const trackVGHOPicked = svs.lyckoplatsen.shared_charity.trackVGHOPicked;
const _svs$tur$pay_lyckopla = svs.tur.pay_lyckoplatsen,
  makePayment = _svs$tur$pay_lyckopla.makePayment,
  setupSubscription = _svs$tur$pay_lyckopla.setupSubscription;
const hasShownBetslipAtom = atom(false);
const BetslipDetailsABTest = () => {
  const _useAtom = useAtom(numberOfWeeksAtom),
    _useAtom2 = _slicedToArray(_useAtom, 2),
    numberOfWeeks = _useAtom2[0],
    setNumberOfWeeks = _useAtom2[1];
  const _useAtom3 = useAtom(shouldAutoPayAtom),
    _useAtom4 = _slicedToArray(_useAtom3, 2),
    shouldAutoPay = _useAtom4[0],
    setShouldAutoPay = _useAtom4[1];
  const _useAtom5 = useAtom(shouldPayAfterDepositAtom),
    _useAtom6 = _slicedToArray(_useAtom5, 2),
    shouldPayAfterDeposit = _useAtom6[0],
    setShouldPayAfterDeposit = _useAtom6[1];
  const _useAtom7 = useAtom(pinLocationAtom),
    _useAtom8 = _slicedToArray(_useAtom7, 2),
    pinLocation = _useAtom8[0],
    setPinLocation = _useAtom8[1];
  const _useAtom9 = useAtom(hasShownBetslipAtom),
    _useAtom0 = _slicedToArray(_useAtom9, 2),
    hasShownBetslip = _useAtom0[0],
    setHasShownBetslip = _useAtom0[1];
  const isProlongination = useAtomValue(isProlonginationAtom);
  const setLocationConfirmed = useSetAtom(locationConfirmedAtom);
  const primaryDraw = useAtomValue(primaryDrawAtom);
  const secondaryDraw = useAtomValue(secondaryDrawAtom);
  const firstDraw = useAtomValue(firstDrawAtom);
  const lastDraw = useAtomValue(lastDrawAtom);
  const pinLocationType = useAtomValue(pinLocationTypeAtom);
  const lyckoplatsenName = useAtomValue(lyckoplatsenNameAtom);
  const shouldDisablePayButton = useAtomValue(shouldDisablePayButtonAtom);
  const locationName = useAtomValue(locationNameAtom);
  const isGameValid = useAtomValue(isGameValidAtom);
  const charity = useAtomValue(charityAtom);
  const isDefultSubscription = useAtomValue(isDefaultSubscriptionAtom);
  const resetPlayAtom = useResetPlayAtoms();
  const history = useHistory();
  const params = useParams();
  const _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    balance = _useState2[0],
    setBalance = _useState2[1];
  const hasMobileKeyboard = svs.lyckoplatsen.hooks.useMobileKeyboardDetect();
  useEffect(() => {
    if (!hasShownBetslip) {
      setHasShownBetslip(true);
      svs.components.analytics.trackEvent({
        category: 'Lyckoplatsen',
        action: 'Förvald prenumeration',
        opt_label: isDefultSubscription
      });
    }
  }, [hasShownBetslip, isDefultSubscription, setHasShownBetslip]);
  useEffect(() => {
    if (svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
      svs.components.account_balance.get(true, balance => {
        setBalance(parseInt(balance, 10));
      });
    }
  }, []);
  if (params.subscriptionId) {
    setNumberOfWeeks(0);
  }
  const isSubscription = numberOfWeeks === 0;

  const shouldShowCancelVGHO = !(isProlongination && isSubscription);
  let startDate = firstDraw;
  let endDate = lastDraw;
  if (numberOfWeeks === 1) {
    const _svs$lyckoplatsen$sha = svs.lyckoplatsen.shared_draws.data.allDraws.sort((a, b) => new Date(a.regCloseTime) - new Date(b.regCloseTime)).slice(0, 3),
      _svs$lyckoplatsen$sha2 = _toArray(_svs$lyckoplatsen$sha),
      firstOneWeek = _svs$lyckoplatsen$sha2[0],
      rest = _arrayLikeToArray(_svs$lyckoplatsen$sha2).slice(1);
    const lastOneWeek = rest[rest.length - 1];
    startDate = firstOneWeek;
    endDate = lastOneWeek;
  }
  const handleIconClick = () => {
    setPinLocation({
      lat: null,
      lng: null
    });
    setLocationConfirmed(false);
  };
  const radioButtons = [
  {
    value: 0,
    text: React.createElement("div", null, "Prenumerera", React.createElement("br", null), " 40 kr/vecka"),
    subText: React.createElement(React.Fragment, null, React.createElement("span", {
      className: "smooth"
    }, "Smidigt val"), React.createElement("div", null, React.createElement(Icon, {
      icon: "checkmark"
    }), "Missa ingen vinstchans"), React.createElement("div", null, React.createElement(Icon, {
      icon: "checkmark"
    }), "Avsluta n\xE4r du vill"))
  }, {
    value: 4,
    text: 'Prova 4 veckor',
    subText: "12 dragningar f\xF6r 160 kr"
  }];
  if (svs.core.detect.feature('ft-lyckoplatsen-selfservice-1w') && isSelfService) {
    radioButtons.unshift({
      value: 1,
      text: 'Spela 1 vecka'
    });
    radioButtons.pop();
  }
  const handlePayFinished = async function () {
    var _charity$charityId;
    let _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      wagerId = _ref.wagerId,
      wasInvalidCharity = _ref.wasInvalidCharity;
    const charityId = wasInvalidCharity ? -2 : (_charity$charityId = charity === null || charity === void 0 ? void 0 : charity.charityId) !== null && _charity$charityId !== void 0 ? _charity$charityId : -1;
    if (isSelfService) {
      setTimeout(() => {
        svs.utils.url.navigate(svs.core.urlMapping.get('startPage'));
      }, 300);
    } else {
      if (charity) {
        trackVGHOPicked(true, charity.name);
      }
      if (isProlongination && params.wagerId) {
        await svs.tur.prolongStorage.set({
          wagerId: params.wagerId,
          productId: 'lyckoplatsen'
        });
      }
      history.push("/relaterat/".concat(wagerId, "/").concat(charityId));
    }
    resetPlayAtom();
  };
  const handlePayClick = () => {
    const data = {
      isProlongination,
      numberOfWeeks,
      product: 'Lyckoplatsen',
      primaryDraw,
      secondaryDraw,
      pinLocation,
      lyckoplatsenName: lyckoplatsenName.trim(),
      pinLocationType,
      charityId: charity === null || charity === void 0 ? void 0 : charity.charityId,
      firstDraw: startDate,
      lastDraw: endDate,
      locationName,
      prolongOriginalWager: svs.lyckoplatsen.data.preloadedWager,
      isAfterDeposit: shouldPayAfterDeposit
    };
    if (isSubscription && !isSelfService) {
      setupSubscription({
        data,
        subscriptionId: params.subscriptionId,
        callback: async () => {
          resetPlayAtom();
          const subscriptionUrlKey = params.subscriptionId ? 'subscriptionChange' : 'subscriptionStart';
          const cancelUrl = encodeURIComponent(svs.utils.url.makeInternal(location.href, svs.core.urlMapping.get('lyckoplatsenHome')));
          const subscriptionPayUrl = "".concat(svs.core.urlMapping.get(subscriptionUrlKey), "?cancelUrl=").concat(cancelUrl, "&product=lyckoplatsen");
          const extraParams = {
            amount: CONSTANTS.PRICE_PER_WEEK,
            branding: 'Lyckoplatsen',
            product: 'Lyckoplatsen',
            subscription: true
          };
          if (svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
            var _svs, _svs$setupExtraData;
            await ((_svs = svs) === null || _svs === void 0 || (_svs = _svs.accountservices) === null || _svs === void 0 || (_svs = _svs.onboardingHandler) === null || _svs === void 0 || (_svs$setupExtraData = _svs.setupExtraData) === null || _svs$setupExtraData === void 0 ? void 0 : _svs$setupExtraData.call(_svs, {
              extraData: extraParams
            }));
            svs.utils.url.navigate(subscriptionPayUrl);
            return;
          }
          svs.components.customer_login.login({
            returnNewCustomer: true,
            returnUrl: subscriptionPayUrl,
            extraParams
          });
        }
      });
    } else {
      makePayment({
        data,
        onDone: handlePayFinished
      });
    }
  };
  useEffect(() => {
    if (svs.core.detect.feature('ft-lyckoplatsen-selfservice-1w') && isSelfService) {
      setNumberOfWeeks(4);
    }
  }, [setNumberOfWeeks]);
  useEffect(() => {
    if (shouldAutoPay) {
      handlePayClick();
      setShouldAutoPay(false);
    }
  }, [shouldAutoPay]);
  if (svs.core.detect.feature('ft-lyckoplatsen-pay-after-deposit') && shouldPayAfterDeposit) {
    if (isGameValid) {
      handlePayClick();
    }
    setShouldPayAfterDeposit(false);
  }
  const handleRadioGroupChange = value => {
    const text = value === 0 ? 'Subscription' : 'Regular';
    svs.components.analytics.trackEvent({
      category: 'Lyckoplatsen',
      action: 'Toggle',
      opt_label: text
    });
    setNumberOfWeeks(value);
  };
  const handleTracking = () => {
    let action = lyckoplatsenName === getDefaultLocationName() ? 'CTA_spela' : 'CTA_spelaName';
    if (isDefultSubscription) {
      action += '_förvald';
    }
    svs.components.analytics.trackEvent({
      category: 'Lyckoplatsen',
      action,
      opt_label: isSubscription ? "Prenumerera ".concat(CONSTANTS.PRICE_PER_WEEK, "kr/vecka") : "Betala ".concat(CONSTANTS.PRICE_PER_WEEK * numberOfWeeks, "kr")
    });
  };
  const SelfServiceGamePeriodPicker = () => {
    if (!svs.core.detect.feature('ft-lyckoplatsen-selfservice-1w')) {
      return React.createElement("div", {
        className: "betslip-selfservice"
      }, numberOfWeeks === 1 ? "Spela 1 vecka, ".concat(CONSTANTS.PRICE_PER_WEEK, " kr") : "Spela ".concat(numberOfWeeks, " veckor, ").concat(numberOfWeeks * CONSTANTS.PRICE_PER_WEEK, " kr (").concat(CONSTANTS.PRICE_PER_WEEK, " kr/vecka)"));
    }
    return React.createElement(ControlGroup, {
      className: "choice-radio-button"
    }, React.createElement(RadioGroup, {
      size: "200"
    }, radioButtons.map(_ref2 => {
      let value = _ref2.value,
        text = _ref2.text;
      return React.createElement(RadioButton, {
        key: value,
        checked: numberOfWeeks === value,
        value: value,
        name: "toggle-choice",
        onChange: () => handleRadioGroupChange(value, text)
      }, text);
    })));
  };
  const DefaultGamePeriodPicker = () => React.createElement(Form, {
    isVertical: true
  }, React.createElement(ControlGroup, {
    className: "choice-radio"
  }, radioButtons.map(_ref3 => {
    let value = _ref3.value,
      text = _ref3.text,
      subText = _ref3.subText;
    return React.createElement(Radio, {
      key: value,
      checked: numberOfWeeks === value,
      value: value,
      name: "toggle-choice-radio",
      onChange: () => handleRadioGroupChange(value, text)
    }, React.createElement("strong", null, text), React.createElement("div", null, subText));
  })));
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "lp-betslip-details lp-betslip-details-ab-test ".concat(hasMobileKeyboard ? 'has-mobile-keyboard' : '')
  }, React.createElement(IconButton, {
    className: "betslip-close",
    onClick: () => handleIconClick(),
    title: "St\xE4ng ikon"
  }, React.createElement(Icon, {
    icon: "close"
  })), React.createElement("div", {
    className: "betslip-choice"
  }, isSelfService ? React.createElement(SelfServiceGamePeriodPicker, null) : React.createElement(DefaultGamePeriodPicker, null), React.createElement(BetslipLocationNameInput, null), React.createElement("div", {
    className: "choice-text"
  }, !charity && React.createElement("span", null, React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none"
  }, React.createElement("g", {
    clipPath: "url(#clip0_4606_1028)"
  }, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1528 0C19.54 0 17.2551 1.37293 15.9997 3.41362C14.7436 1.37293 12.4587 0 9.84655 0C5.88732 0 2.66667 3.14184 2.66667 7.00352C2.66667 8.87928 3.42991 10.5801 4.65998 11.8428L7.06079 14.1877L13.0403 20.0283C10.7708 20.1841 8.60331 21.0713 6.87282 22.5659C5.37482 23.8605 3.45851 24.5725 1.47744 24.5725H7.62939e-06L0 32H22.3016C23.8308 32 25.2671 31.592 26.346 30.5122L30.9985 25.8564C32.335 24.5169 32.3334 22.3413 30.9962 21.0049C29.6575 19.6646 27.4791 19.6654 26.1411 21.0049L23.5763 23.5681C22.9279 24.2161 22.0669 24.5725 21.1511 24.5725H20.5643C20.6908 24.2146 20.7601 23.8301 20.7601 23.4302C20.7601 22.0237 19.9075 20.8122 18.6917 20.2849L24.4565 14.6667L27.2175 11.963C28.5229 10.6936 29.3333 8.93937 29.3333 7.00352C29.3333 3.14184 26.1127 0 22.1528 0ZM15.9149 20.0035H16.0765L21.5502 14.6667L25.819 10.4946C26.7199 9.59111 27.2798 8.36109 27.2798 7.00352C27.2798 4.24632 24.9798 2.0033 22.1528 2.0033C19.7645 2.0033 17.7582 3.60727 17.1914 5.76749H14.8072C14.2405 3.60727 12.2348 2.0033 9.84655 2.0033C7.02019 2.0033 4.72022 4.24632 4.72022 7.00352C4.72022 8.36109 5.27947 9.59111 6.18234 10.4933L9.7741 14L15.9149 20.0035ZM29.3809 24.2412C29.8281 23.795 29.8266 23.067 29.3801 22.6208C28.9321 22.1731 28.2052 22.1738 27.7572 22.6201L25.1917 25.1832C24.1136 26.2615 22.6772 26.8562 21.1511 26.8562H12.9531V24.5717H17.3306C17.9607 24.5717 18.4735 24.0592 18.4735 23.4295C18.4735 22.799 17.9607 22.2872 17.3306 22.2872H13.7616C11.781 22.2873 9.86644 22.9992 8.36694 24.2931C6.66247 25.765 4.24547 26.6524 2.00001 26.825L2 29.7147H22.3016C23.219 29.7147 24.08 29.5451 24.7284 28.8971L29.3809 24.2412Z",
    fill: "#001932"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "clip0_4606_1028"
  }, React.createElement("rect", {
    width: "32",
    height: "32",
    fill: "white"
  })))), "Efter betalning v\xE4ljer du en organisation som vi st\xF6ttar n\xE4r du spelar."))), charity && React.createElement("div", {
    className: "betslip-charity elevation-200"
  }, "Ditt spel st\xF6ttar", React.createElement("div", {
    className: "betslip-charity-logo"
  }, React.createElement(CharityLogoABTest, {
    isRemoveable: shouldShowCancelVGHO
  })))), balance !== null && !isSubscription && React.createElement("p", null, "Ditt saldo: ", formatCurrency(balance), " kr"), React.createElement(Button, {
    block: true,
    size: isSelfService ? 700 : 500,
    disabled: shouldDisablePayButton,
    className: "lp-green lp-pay-button",
    onClick: () => {
      handlePayClick();
      handleTracking();
    }
  }, "G\xE5 till betalning"));
};
setGlobal('svs.lyckoplatsen.components.page_play.react.components', {
  BetslipDetailsABTest
});

 })(window);